module.exports = __webpack_public_path__ + "static/Gibson-Regular-webfont-54c152fe827d9dbfb5cc36cbd08a8923.woff";